import React from 'react'
import type { FC } from 'react'
import InstoreCartContainer from '@/checkout-instore-legacy/cart/containers/CartContainer'
import AppContainer from '@/checkout-instore-legacy/components/AppContainer'

export const Cart: FC = () => {
  return (
    <AppContainer>
      <InstoreCartContainer />
    </AppContainer>
  )
}
